export default {
    STORE_USER_DETAIL: 'STORE_USER_DETAIL',
    PROGRESS_INCREMENT: 'PROGRESS_INCREMENT',
    PROGRESS_DECREMENT: 'PROGRESS_DECREMENT',
    PROGRESS_RESET: 'PROGRESS_RESET',
};
